const styles = {
  container: {
  display: "flex",
  height: "100vh",
  overflow: "hidden", // ✅ только внутри чата
  background: "#0f0f0f",
  color: "#fff"
},

  sideBtn: {
    width: "40px",
    height: "40px",
    borderRadius: "12px",
    border: "none",
    background: "transparent",
    color: "#aaa",
    cursor: "pointer",
  },

  rightSide: {
  flex: 1,
  display: "flex",
  flexDirection: "column",
    overflow: "visible"
},

favInline: {
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  opacity: 0.8,
},

  mainTopBar: {
    height: "60px",
    minHeight: "60px",     // 🔥 фикс высоты
    flexShrink: 0,         // 🔥 ЗАПРЕТ СЖАТИЯ
    borderBottom: "1px solid #222",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "0 20px",
  },


chatList: {
  background: "#1a1a1a",
  borderRight: "1px solid #222",
  overflowY: "auto",
  overflowX: "hidden", // 🔥 УБИРАЕТ ГОРИЗОНТАЛЬНЫЙ СКРОЛЛ

  width: "100%",   // 🔥 ВОТ ЭТО ГЛАВНОЕ
},

  avatar: { width: "40px", height: "40px", borderRadius: "50%" },

  chatArea: {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden", // ❗ ключ

  height: "100%",        // 🔥 КРИТИЧНО
  minHeight: 0,          // 🔥 фикс переполнения
},

  chatHeader: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "10px",
    borderBottom: "1px solid #222",
  },

  status: { fontSize: "12px", color: "#888" },

  messages: {
  flex: 1,
  padding: "10px",
  display: "flex",
  flexDirection: "column",
  gap: "10px",

  overflowY: "auto",   // ✅ скролл только тут
  height: "100%",      // ✅ важно
  minHeight: 0, // 🔥 ОЧЕНЬ ВАЖНО
},

  msgLeft: { background: "#222", padding: "10px", borderRadius: "10px", width: "fit-content" },

  msgRight: {
    background: "#2b2b2b",
    padding: "10px",
    borderRadius: "10px",
    width: "fit-content",
    alignSelf: "flex-end",
  },

  inputArea: { display: "flex", gap: "10px", padding: "10px", borderTop: "1px solid #222" },

  input: {
    flex: 1,
    padding: "10px",
    borderRadius: "10px",
    border: "none",
    background: "#1f1f1f",
    color: "#fff",

      flexShrink: 0, // 🔥 запрещаем сжатие
  },

  image: {
  width: "100%",
  maxWidth: 250,
  borderRadius: 12,
  marginTop: 5,
  },

  empty: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    color: "#666",
  },

  msgMeta: {
  fontSize: 11,
  opacity: 0.6,
  marginTop: 4,
  textAlign: "right",
},

typing: {
  fontSize: 13,
  opacity: 0.7,
  padding: "4px 10px",
},
sidebar: {
  width: 70,
  background: "#0f0f0f",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  paddingTop: 20,
  gap: 20,
  borderRight: "1px solid rgba(255,255,255,0.05)",
},

sidebarItem: {
  width: 48,
  height: 48,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: 14,
  fontSize: 20,
  color: "#aaa",
  cursor: "pointer",
  transition: "all 0.2s ease",
},

sidebarItemActive: {
  background: "rgba(255,255,255,0.08)",
  color: "#fff",
  boxShadow: "0 0 10px rgba(255,255,255,0.05)",
},

chatWrapper: {
  display: "flex",
  flex: 1,
  height: "100%",
  overflow: "hidden",
  transition: "all 0.25s ease",
},

chatCenter: {
  flex: 1,
  display: "flex",
  justifyContent: "center", // 🔥 центр
  alignItems: "stretch",
  padding: "20px",
},

chatContainer: {
  flex: 1, // 🔥 вместо maxWidth
  background: "#111",
  borderRadius: "0px", // убираем карточку
  borderLeft: "1px solid rgba(255,255,255,0.05)", // аккуратная граница
  display: "flex",
  flexDirection: "column",
},

chatItem: {
  display: "flex",
  alignItems: "center",

  width: "100%",        // 🔥 РАСТЯГИВАЕМ
  boxSizing: "border-box",

  padding: "12px 14px",
  margin: 0,            // ❗ УБИРАЕМ отступы, они ломают ширину

  borderRadius: 0,      // ❗ чтобы выглядело как цельный список
  cursor: "pointer",

  borderBottom: "1px solid rgba(255,255,255,0.05)",

  transition: "all 0.2s ease",
},

chatItemHover: {
  background: "rgba(255,255,255,0.06)",
},

msgAvatar: {
  width: 34,
  height: 34,
  borderRadius: "50%",
  cursor: "pointer",
  objectFit: "cover",
},

msgBubble: {
  maxWidth: "65%",
  animation: "fadeIn 0.2s ease",
  padding: "8px 12px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
  borderRadius: 16,
  position: "relative",
  wordBreak: "break-word",
},

myBubble: {
  background: "rgba(255,255,255,0.06)",
  border: "1px solid rgba(255,255,255,0.18)",
  backdropFilter: "blur(12px)",
  boxShadow: "0 4px 20px rgba(0,0,0,0.25)",
},

metaRight: {
  display: "flex",
  alignItems: "center",
  gap: 6,
},

// 💬 ЧУЖИЕ (чуть плотнее и контрастнее)
otherBubble: {
  background: "#2a2a2a",
  color: "#ddd",
},

replyBtn: {
  background: "rgba(255,255,255,0.1)",
  border: "none",
  borderRadius: "10px",
  padding: "4px 6px",
  cursor: "pointer",
  backdropFilter: "blur(10px)",
  color: "#fff",
  opacity: 0.7
},

replyPreview: {
  background: "rgba(255,255,255,0.05)",
  borderLeft: "3px solid rgba(255,255,255,0.15)",
  padding: "6px 8px",
  marginBottom: 6,
  borderRadius: 8,
},

bubbleActions: {
  display: "flex",
  justifyContent: "flex-end",
  marginTop: 6,
},

bottomRow: {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: 6,
  gap: 8,
},

shimmer: {
  position: "absolute",
  top: 0,
  left: "-150%",
  width: "300%",
  height: "100%",

  background:
    "linear-gradient(120deg, transparent 30%, rgba(255,255,255,0.12) 50%, transparent 70%)",

  animation: "shimmerMove 3.5s cubic-bezier(0.4, 0, 0.2, 1) infinite",
  pointerEvents: "none",
},

glassOverlay: {
  position: "absolute",
  inset: 0,

  background: "rgba(255,255,255,0.04)",
  backdropFilter: "blur(6px)",

  pointerEvents: "none",
},

toolbar: {
  position: "absolute",
  top: 10,
  left: "50%",

  transform: "translateX(-50%) scale(0.9)",
  opacity: 0,

  minWidth: 220,
  padding: "10px 14px",
  borderRadius: 16,

  background: "rgba(20,20,20,0.55)",
  backdropFilter: "blur(18px)",

  border: "1px solid rgba(255,255,255,0.1)",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  zIndex: 1000,
  overflow: "visible",

  animation: "toolbarSpring 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) forwards",
},

toolbarInner: {
  minWidth: 220,
  padding: "10px 14px",
  borderRadius: 16,

  background: "rgba(20,20,20,0.55)",
  backdropFilter: "blur(18px)",

  border: "1px solid rgba(255,255,255,0.1)",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  overflow: "hidden", // ✅ shimmer режется тут
  position: "relative",
},

toolbarContent: {
  display: "flex",
  alignItems: "center",
  gap: 12,
  position: "relative",
  zIndex: 2,
},

toolbarBtn: {
  background: "rgba(255,255,255,0.05)",
  border: "1px solid rgba(255,255,255,0.1)",
  borderRadius: 10,
  padding: "6px",
  cursor: "pointer",
  color: "#fff",
  transition: "all 0.2s ease",
},

toolbarCount: {
  fontSize: 14,
  opacity: 0.7,
},

toolbarShimmer: {
  position: "absolute",
  inset: 0,
  borderRadius: 16,
  overflow: "hidden", // ✅ режем shimmer ТУТ
},

tooltipWrap: {
  position: "relative",
  display: "flex",
  alignItems: "center"
},

tooltip: {
  position: "absolute",
  top: "120%", // 🔥 вместо bottom
  left: "50%",
  transform: "translateX(-50%)",

  fontSize: 11,
  padding: "4px 8px",
  borderRadius: 6,

  whiteSpace: "nowrap",

  background: "rgba(20,20,20,0.9)",
  border: "1px solid rgba(255,255,255,0.1)",
  backdropFilter: "blur(10px)",

  pointerEvents: "none",
  transition: "0.15s",
  zIndex: 10
},

tooltipWrapHover: {
  opacity: 1,
  transform: "translateX(-50%) translateY(-2px)",
},

favIcon: {
  position: "absolute",
  top: -6,
  right: -6,
  fontSize: 12,
  background: "rgba(255,255,255,0.08)",
  border: "1px solid rgba(255,255,255,0.2)",
  backdropFilter: "blur(8px)",
  borderRadius: 8,
  padding: "2px 4px",
},

favBadge: {
  position: "absolute",
  top: 6,
  right: 6,

  background: "rgba(255,255,255,0.1)",
  backdropFilter: "blur(6px)",

  borderRadius: "50%",
  width: 18,
  height: 18,

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  border: "1px solid rgba(255,255,255,0.15)"
},

favBadge: {
  position: "absolute",
  top: 6,
  right: 8,

  width: 18,
  height: 18,

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  borderRadius: 6,
  background: "rgba(255,255,255,0.06)",
  backdropFilter: "blur(6px)",

  border: "1px solid rgba(255,255,255,0.1)",
},

favInlineRight: {
  position: "absolute",
  top: 6,
  right: 8,

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  width: 18,
  height: 18,

  borderRadius: 6,
  background: "rgba(255,255,255,0.06)",
  backdropFilter: "blur(6px)",

  border: "1px solid rgba(255,255,255,0.1)"
},

skeletonAvatar: {
  width: 40,
  height: 40,
  borderRadius: "50%",
  background: "rgba(255,255,255,0.06)",
},

skeletonLine: {
  height: 10,
  width: "60%",
  borderRadius: 6,
  marginBottom: 6,
  background:
    "linear-gradient(90deg, rgba(255,255,255,0.05), rgba(255,255,255,0.12), rgba(255,255,255,0.05))",
  backgroundSize: "200% 100%",
  animation: "shimmer 1.5s infinite",
},

skeletonLineSmall: {
  height: 8,
  width: "40%",
  borderRadius: 6,
  background: "rgba(255,255,255,0.04)",
},

unreadBadge: {
  marginLeft: "auto",
  background: "#fff",
  color: "#000",
  fontSize: 11,
  padding: "2px 6px",
  borderRadius: 10,
  minWidth: 18,
  textAlign: "center",
},

// ===============================
// 🔥 SKELETON GLASS
// ===============================
skeletonItem: {
  display: "flex",
  alignItems: "center",
  gap: 10,
  padding: "10px 12px",
  borderRadius: 14,

  background: "rgba(255,255,255,0.04)",
  backdropFilter: "blur(12px)",

  marginBottom: 6,
  position: "relative",
  overflow: "hidden",

  border: "1px solid rgba(255,255,255,0.05)",
},

skeletonAvatar: {
  width: 42,
  height: 42,
  borderRadius: "50%",
  background: "rgba(255,255,255,0.08)",
},

skeletonLineShort: {
  width: "40%",
  height: 10,
  borderRadius: 6,
  background: "rgba(255,255,255,0.08)",
  marginBottom: 6,
},

skeletonLineLong: {
  width: "70%",
  height: 10,
  borderRadius: 6,
  background: "rgba(255,255,255,0.06)",
},

// ✨ shimmer
skeletonShimmer: {
  position: "absolute",
  top: 0,
  left: "-100%",
  width: "100%",
  height: "100%",
  background:
    "linear-gradient(90deg, transparent, rgba(255,255,255,0.08), transparent)",
  animation: "shimmer 1.6s infinite",
},

emptyState: {
  padding: 20,
  textAlign: "center",
  opacity: 0.5,
  fontSize: 14,
},

iconBtn: {
  width: 32,
  height: 32,
  borderRadius: 10,
  border: "1px solid rgba(255,255,255,0.1)",
  background: "rgba(255,255,255,0.05)",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
},

messageAppear: {
  opacity: 0,
  transform: "translateY(10px) scale(0.98)",
  animation: "msgIn 0.25s ease forwards",
},

// можно чуть разные задержки
messageAppearFast: {
  animation: "msgIn 0.18s ease forwards",
},

};

export default styles;